import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const defaultStyle = {
  container: {
    borderColor: '#EBEBEB' as ColorOptions,
    borderWidth: 1,
    borderRadius: 3,
  } as ViewStyle,

  seperator: {
    borderLeftWidth: 1,
    borderColor: '#F0F0F0' as ColorOptions,
  } as BoxProps,

  tab: {
    //  flex: 1, not working for ie
    flexDirection: 'row',
    flexWrap: 'wrap',
  } as BoxProps,
}

const styles = {
  default: {
    ...defaultStyle,
  },
  highlights: {
    ...defaultStyle,
  },
  recentPayments: {
    ...defaultStyle,
    container: {
      // Todo: Check this again
      // borderWidth: 0.7,
      borderRadius: 4,
      alignSelf: 'flex-start',
    } as ViewStyle,
    tab: {
      //  flex: 1, not working for ie
      borderColor: 'LIGHTEST_GREY',
      flexDirection: 'row',
      flexWrap: 'wrap',
      borderWidth: 1,
    } as BoxProps,
    seperator: {} as BoxProps,
  },
  profile: {
    ...defaultStyle,
  },
  bulkEntity: {
    ...defaultStyle,
    container: {
      // Todo: Check this again
      // borderWidth: 0.7,
      borderRadius: 6,
      alignSelf: 'flex-start',
    } as ViewStyle,
    tab: {
      //  flex: 1, not working for ie
      borderColor: 'LIGHTEST_GREY',
      flexDirection: 'row',
      flexWrap: 'wrap',
      borderWidth: 1,
    } as BoxProps,
  },
  documentation: {
    ...defaultStyle,
    container: {
      // Todo: Check this again
      // borderWidth: 0.7,
      borderRadius: 4,
      alignSelf: 'flex-start',
    } as ViewStyle,
    tab: {
      //  flex: 1, not working for ie
      borderColor: 'LIGHTEST_GREY',
      flexDirection: 'row',
      flexWrap: 'wrap',
      borderWidth: 1,
    } as BoxProps,
    seperator: {} as BoxProps,
  },
}

export default styles
